import api from './api';

export default {
  getAll() { return api.get('/payment-channels'); },
  getById(id: number) { return api.get(`/payment-channels/${id}`); },
  create(data: any) { return api.post('/payment-channels', data); },
  update(id: number, data: any) { 
    if (data instanceof FormData) {
      data.append('_method', 'PUT');
      return api.post(`/payment-channels/${id}`, data);
    }
    return api.put(`/payment-channels/${id}`, data); 
  },
  delete(id: number) { return api.delete(`/payment-channels/${id}`); }
};
